import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import AssetBrandCodeService from "services/Setup/Master/assetBrandCodeService";
import { message, notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  assetBrandCodeList: {},
};

export const getAssetBrandCodeList = createAsyncThunk(
  "assetBrandCode/getAssetBrandCodeList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await AssetBrandCodeService.getAssetBrandCodeList(
        userInput
      );
      console.log("🚀 ~ responsegetAssetBrandCodeList:", response);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getassetMastersSliceListSerch = createAsyncThunk(
  "assetBrandCode/getassetMastersSliceListSerch",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await AssetBrandCodeService.getassetMastersSliceListSerch(userInput);
      console.log("🚀 ~ responsegetassetMastersSliceListSerch:", response);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const assetBrandCode = createSlice({
  name: "assetBrandCode",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder
      //get assetBrand code list
      .addCase(getAssetBrandCodeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getAssetBrandCodeList.fulfilled, (state, action) => {
         
        state.loading = false;
        state.assetBrandCodeList = action.payload;
      })
      .addCase(getAssetBrandCodeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //getgetassetMastersSliceListSerch
      .addCase(getassetMastersSliceListSerch.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getassetMastersSliceListSerch.fulfilled, (state, action) => {
        state.loading = false;
        state.assetBrandCodeList = action.payload;
      })
      .addCase(getassetMastersSliceListSerch.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const { showNotification, hideNotification, showLoading } =
  assetBrandCode.actions;

export default assetBrandCode.reducer;
